import styled from 'styled-components'

export const TabControl = styled.button`
  padding: 18px 24px;
  border: none;
  height: 60px;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  background-color: transparent;

  &.active {
    color: ${ (props) => props.theme.colors['aok-gruen'] };
    border-bottom: 4px solid ${ (props) => props.theme.colors['aok-gruen'] };
  }

  &:not(.active):hover {
    color: ${ (props) => props.theme.colors.hellgruen1 };
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline-offset: 2px;
  }
`
